住所情報登録
<template>
  <div class="l-modal__bg" v-if="loading"></div>

  <div class="address">
    <div v-show="loading" class="loading">
      <img src="../assets/loading.gif" />
    </div>
    <!-- <header class="header">
      <img src="../assets/omi-logo.svg" />
    </header> -->
    <!-- <div class="title">
        <p v-if="!isUser">事前登録受付</p>
        <p v-else>ユーザー情報更新</p>
      </div> -->
    <Form
      class="form h-adr"
      :validationSchema="validationSchema"
      v-slot="{ meta: { valid } }"
    >
      <span class="“p-country-name”" style="display: none">Japan</span>
      <div style="padding-bottom: 500px">
        <div style="padding-top: 40px">
          <label>郵便番号</label>
          <div class="text-area">
            <Field
              class="text-field p-postal-code"
              type="text"
              inputmode="numeric"
              name="postalCode"
              v-model="postalCode"
              v-on:blur="fetchAddress()"
              tabindex="1"
            />
            <div>
              <ErrorMessage name="postalCode" v-slot="{ message }"
                ><p class="error">{{ message }}</p></ErrorMessage
              >
            </div>
          </div>
        </div>

        <div style="padding-top: 40px">
          <label>都道府県</label>
          <div class="text-area">
            <Field
              class="select-field p-region"
              as="select"
              name="prefecture"
              v-model="prefecture"
              tabindex="2"
            >
              <option
                v-for="[val] of Array.from(PREFECTURE)"
                v-bind:value="val"
                v-bind:key="val"
                class="p-region"
              >
                {{ val }}
              </option>
            </Field>
            <div>
              <ErrorMessage name="prefecture" v-slot="{ message }"
                ><p class="error">{{ message }}</p></ErrorMessage
              >
            </div>
          </div>
        </div>

        <div style="padding-top: 40px">
          <label>市区町村</label>
          <div class="text-area">
            <Field
              class="text-field p-locality"
              type="text"
              name="city"
              v-model="city"
              tabindex="3"
            />
            <div>
              <ErrorMessage name="city" v-slot="{ message }"
                ><p class="error">{{ message }}</p></ErrorMessage
              >
            </div>
          </div>
        </div>

        <div style="padding-top: 40px">
          <label>番地</label>
          <div class="text-area">
            <Field
              class="text-field p-street-address p-extended-address"
              type="text"
              name="street"
              placeholder="1-1-1"
              v-model="street"
              tabindex="4"
            />
            <div>
              <ErrorMessage name="street" v-slot="{ message }"
                ><p class="error">{{ message }}</p></ErrorMessage
              >
            </div>
          </div>
        </div>

        <div style="padding-top: 40px">
          <label>建物名・部屋番号</label>
          <div class="text-area">
            <Field
              class="text-field"
              type="text"
              name="building"
              placeholder="〇〇マンション101"
              v-model="building"
              tabindex="5"
            />
            <div>
              <ErrorMessage name="building" v-slot="{ message }"
                ><p class="error">{{ message }}</p></ErrorMessage
              >
            </div>
          </div>
        </div>

        <div style="padding-top: 40px">
          <label>電話番号</label>
          <div class="text-area">
            <Field
              type="text"
              inputmode="numeric"
              v-model="phoneNumber"
              name="phoneNumber"
              placeholder="09000000000"
              class="text-field"
              :disabled="loading || deleting"
              tabindex="7"
            />
            <div>
              <ErrorMessage name="phoneNumber" v-slot="{ message }"
                ><p class="error">{{ message }}</p></ErrorMessage
              >
            </div>
          </div>
        </div>

        <div style="padding-top: 40px">
          <label>名前</label>
          <div class="text-area">
            <Field
              type="text"
              v-model="name"
              name="name"
              placeholder="山田 太郎"
              class="text-field"
              :disabled="loading || deleting"
              tabindex="8"
            />
            <div>
              <p style="font-size: 12px; color: #2c3e50">
                ※職場などの場合は、会社名 部署 氏名まで入力してください
              </p>
              <ErrorMessage name="name" v-slot="{ message }"
                ><p class="error">{{ message }}</p></ErrorMessage
              >
            </div>
          </div>
        </div>
      </div>
      <div class="button-area">
        <common-button
          :data="{
            status: !valid || loading ? 2 : 0,
            button: deleting ? `登録中` : `登録`,
          }"
          @click="valid && !loading && !deleting ? onSubmit() : ''"
          v-if="userInfoStore.addressInfo.id < 0"
        ></common-button>
        <common-button
          :data="{
            status: !valid || loading ? 2 : 0,
            button: loading ? `更新中` : `更新`,
          }"
          @click="valid && !loading && !deleting ? onSubmit() : ''"
          :disabled="!valid || loading"
          style="margin-bottom: 20px"
          v-else
        ></common-button>

        <common-button
          :data="{
            status: 3,
            button: deleting ? `削除中` : `削除`,
          }"
          @click="!loading && !deleting ? deleteAddressInfo() : ''"
          v-if="userInfoStore.addressInfo.id > 0"
        ></common-button>
      </div>
    </Form>
  </div>
</template>

<script setup lang="ts">
import { onBeforeMount, ref } from "vue";
import { UserInfoStore } from "../store/UserInfoStore";
import { Field, Form, ErrorMessage } from "vee-validate";
import CommonButton from "./CommonButton.vue";

import * as yup from "yup";
import { Core as YubinBangoCore } from "yubinbango-core2";
import { addressRegistRequest } from "../types/apiRequest";
import { useRouter } from "vue-router";
import { PREFECTURE } from "../consts/common";

const postalCode = ref("");
const prefecture = ref("");
const city = ref("");
const street = ref("");
const building = ref("");
const phoneNumber = ref("");
const name = ref("");
const updated = ref(false);
const router = useRouter();
const userInfoStore = UserInfoStore();
const loading = ref(false);
const deleting = ref(false);
const validationSchema = ref(
  yup.object().shape({
    postalCode: yup
      .string()
      .trim()
      .required("郵便番号は必須です")
      .min(1)
      .label("郵便番号"),
    prefecture: yup
      .string()
      .trim()
      .required("都道府県は必須です")
      .min(1)
      .label("都道府県"),
    city: yup.string().trim().required("市区町村は必須です").label("市区町村"),
    street: yup.string().trim().required("番地は必須です").label("番地"),
    phoneNumber: yup
      .string()
      .trim()
      .required("電話番号は必須です")
      .label("電話番号"),
    name: yup.string().trim().required("名前は必須です").label("名前"),
  })
);
onBeforeMount(async () => {
  if (userInfoStore.addressInfo.id < 0) {
    await userInfoStore.getAddressInfo().then(() => {
      if (userInfoStore.addressInfo.id < 0) {
        document.title = "配送先住所登録";
        return;
      }
      setInitialData();
    });
  } else {
    // 登録済の情報を初期値で入れる
    setInitialData();
  }
});

const setInitialData = () => {
  if (userInfoStore.addressInfo.id < 0) return;
  document.title = "配送先住所更新";
  postalCode.value = userInfoStore.addressInfo.postal_code;
  prefecture.value = userInfoStore.addressInfo.prefecture;
  city.value = userInfoStore.addressInfo.city;
  street.value = userInfoStore.addressInfo.street;
  building.value = userInfoStore.addressInfo.building || "";
  phoneNumber.value = userInfoStore.addressInfo.phone_number;
  name.value = userInfoStore.addressInfo.name;
};

function fetchAddress() {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  new YubinBangoCore(postalCode.value, function (addr: any) {
    // region=都道府県, locality=市区町村, street=町域
    prefecture.value = addr.region;
    city.value = addr.locality + addr.street;
  });
}

// 登録処理
const onSubmit = async () => {
  // 複数回リクエストが飛ばないようにする
  if (loading.value) return;
  loading.value = true;
  const request: addressRegistRequest = {
    postal_code: postalCode.value, //郵便番号
    prefecture: prefecture.value, //都道府県
    city: city.value, //市区町村
    street: street.value, //番地以降
    building: building.value || "", //ビル名など
    phone_number: phoneNumber.value, //電話番号
    name: name.value, //名前
  };

  await userInfoStore.updateAddressInfo(request).then((v) => {
    if (v) {
      updated.value = true;
      router.go(-1);
    }
    loading.value = false;
  });
};
async function deleteAddressInfo() {
  deleting.value = true;
  await userInfoStore.deleteAddressInfo().then((v) => {
    if (v) {
      updated.value = true;
      setTimeout(() => router.go(-2), 100);
    }

    deleting.value = false;
  });
}
</script>
<style lang="scss" scoped>
@import "../assets/style/_variables.scss";
@import "../assets/style/mixin.scss";

.address {
  // touch-action: none;
  overflow: auto;
  width: 100%;
  max-width: 480px;
  height: 100%;
  max-height: 810px;
  scrollbar-gutter: stable;
}
.address::-webkit-scrollbar {
  display: none;
}
.header {
  text-align: center;
  width: 100%;
}

label {
  font-size: $FONT_SIZE_M;
}
.form {
  width: 100%;
  max-width: 307px;
  margin: 0 auto;
  // font-family: $font-family-hiragino-gothic-pron;
  // text-align: center;
}
.error {
  color: red;
  text-align: center;
  margin: 0;
}
.title {
  margin-top: 40px;
  text-align: center;
  // font-family: $font-family-hiragino-gothic-pron;
  font-style: normal;
  font-weight: 600;
  font-size: $FONT_SIZE_L;
  line-height: 24px;
  height: 60px;
  width: 100%;
  max-width: 480px;
  background-color: rgba(8, 110, 182, 0.04);
  > p {
    margin: 0;
    padding-top: 18px;
  }
}
.button-area {
  width: 100%;
  max-width: 317px;
  margin: 0 auto;
  text-align: center;
  display: block;
  position: fixed;
  bottom: 80px;
  font-size: $FONT_SIZE_M;
  line-height: 21px;
  padding-top: 10px;
  // width: 200px;
  margin: 0 auto;
}
.loading {
  display: flex;
  position: absolute;
  justify-content: center;
  top: 50%;
  z-index: 9999;
  img {
    width: 10%;
    height: 10%;
  }
}
.text-area {
  width: 307px;
  margin: 0 auto;
  padding-top: 8px;
}
.text-field {
  width: 307px;
  height: 48px;
  border: 1px solid #777777;
  border-radius: 2px;
  background-color: $white;
  padding: 0 0 0 8px;
  font-size: $FONT_SIZE_M;
}
.select-field {
  width: 317px;
  height: 48px;
  border: 1px solid #777777;
  color:black;
  border-radius: 2px;
  background-color: $white;
  padding: 0 0 0 8px;
  font-size: $FONT_SIZE_M;
}
.radio-button-area {
  width: 307px;
  // margin: 0 auto;
  padding-top: 22px;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
}
label {
  padding-right: 32px;
  padding-left: 8px;
}
input[type="radio"] {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}

input[type="radio"] {
  position: relative;
  width: 21px;
  height: 21px;
  border: 1px solid #999999;
  border-radius: 50%;
  vertical-align: -2px;
}

input[type="radio"]:checked:before {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 13px;
  height: 13px;
  border-radius: 50%;
  background: #999999;
  border: 1px solid #999999;
  content: "";
  // content: url("../assets/radio.svg");
}
.l-modal__bg {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.75);
  position: fixed;
  top: 0;
  left: 0;
  text-align: center;
  z-index: 999;
}
</style>
